var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', {
    staticClass: "text-primary"
  }, [_vm._v("折價券兌換")]), _c('h2', [_vm._v("折價券通路選擇")]), _c('div', {
    staticClass: "p-4"
  }, [_c('a', {
    staticClass: "button my-4",
    on: {
      "click": function click($event) {
        return _vm.goto('LiffHuggiesCouponOffline');
      }
    }
  }, [_c('span', {
    staticClass: "h4 mb-0 font-weight-bold text-black"
  }, [_vm._v("實體通路")]), _c('span', {
    staticClass: "h4 mb-0 font-weight-bold text-primary"
  }, [_vm._v("50元折價券")])]), _c('a', {
    staticClass: "button my-4",
    on: {
      "click": function click($event) {
        return _vm.goto('LiffHuggiesCouponEC');
      }
    }
  }, [_c('span', {
    staticClass: "h4 mb-0 font-weight-bold text-black"
  }, [_vm._v("電商通路")]), _c('span', {
    staticClass: "h4 mb-0 font-weight-bold text-primary"
  }, [_vm._v("50元折價券")])]), _c('div', {
    staticClass: "h5 text-danger font-weight-bold"
  }, [_vm._v("注意!!")]), _vm._m(0)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-danger small"
  }, [_vm._v("實體通路與電商通路 "), _c('br'), _vm._v("僅能擇一領取")]);
}]

export { render, staticRenderFns }